import React, { useEffect, useState } from 'react';
import SinglePart from './SinglePart';
import { useQuery } from 'react-query';
import Loding from '../Shared/Loding'
import useAxios from '../../hooks/useAxios';
import Swal from 'sweetalert2';
const CarParts = () => {
   const axiosPublic=useAxios()
    // const [parts,setparts]=useState([]);
    const{data:parts, isLoading,isError,error} =useQuery('part', ()=>axiosPublic.get('/part').then(res=>res.data).catch(err=>{
     

          
      Swal.fire({
        title: `${err.code}`,
      
        icon: 'error',
        showConfirmButton:false,

        timer: 2500
    });
    }))
  
  
   
   
    
   if(isLoading){
        return <Loding></Loding>
    }     
   if(isError){
    return <pre className='mt-5'>{error.message}</pre>
   }

    return (
     <section className='py-[90px]  bg-[#FAF7F2]'>
      
      <div className='max-w-[1170px] mx-auto  px-5 md:px-0 '>
            <h2 className='text-3xl  font-bold text-center mb-5'> OUR CAR <span className='text-primary'>PARTS</span> </h2>
        
       
           <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>

         {
             parts?.map(part=><SinglePart key={part._id} part={part}></SinglePart>)
         }


           </div>
       

          
             
        </div>
     </section>
    );
};

export default CarParts;